import { useRecoilState } from "recoil";
import { mostrarDespesaPessoal } from "../atom";

const useMostrarDespesaPessoalState = () => {
    return useRecoilState(mostrarDespesaPessoal);
};

export default useMostrarDespesaPessoalState;